import React, { Fragment } from 'react'

import getLabels from '../../utils/getLabels'

import PreFillNewBookingPassengers from '../../containers/PreFillNewBookingPassengers'

import CSVUploadText from '../CSVUploadText'

import styles from './CSVUpload.module.scss'

interface CSVUploadPropsInterface {
  pristine: boolean
}

export default (props: CSVUploadPropsInterface) => (
  <Fragment>
    <h2 className={styles['title']}>{getLabels('csv_upload_title')}</h2>

    <CSVUploadText />

    <div className={styles['form-container']}>
      <PreFillNewBookingPassengers pristine={props.pristine} />
    </div>
  </Fragment>
)
